(function() {
    var subTabItemTemplate = '<li><a href="#{{categoryId}}">{{categoryName}}</a></li>';
    var storyListItemTemplate = '<li><a href="{{storyUrl}}">' +
        '<div class="thumb">' +
        '<img src="{{storyMainThumbnailPath}}{{storyMainThumbnailServerName}}" alt="" aria-hidden="true">' +
        '</div>' +
        '<div class="badge-wrap">' +
        '<span class="badeg">{{storyTypeName}}</span>' +
        '</div>' +
        '<p class="tit">{{#raw storyTitle}}</p>' +
        '<p class="desc">{{#raw storyDesc}}</p>' +
        '</a></li>';

    var KRP0026 = {
        init: function() {
            var self = this;
            vcui.require(['ui/pagination'], function () {
                self.setting();
                self.bindEvents();
            });
        },

        setting: function() {
            var self = this;

            self.$section = $('.KRP0026');
            var $pageHeader = self.$section.find('div.page-header');
            var $tabs = $pageHeader.find('div.ui_tab');
            self.$mainTab = $tabs.eq(0);
            self.$subTab = $tabs.eq(1);

            //var $sortList = self.$section.find('div.sort-list');
            //self.$selectOrder = $sortList.find('.ui_selectbox');
            self.$totalCounter = self.$section.find('#totalCount');
            self.$list = self.$section.find('ul.story-list-box');
            self.$pagination = self.$section.find('.pagination').vcPagination();

            // self.section.find('.ui_carousel_slider').vcCarousel({
            //     settings: "unslick",
            //     responsive: [
            //         {
            //             breakpoint: 10000,
            //             settings: "unslick"
            //         },
            //         {
            //             breakpoint: 768,
            //             settings: {
            //                 infinite: false,
            //                 dots: true,
            //                 slidesToShow: 1,
            //                 slidesToScroll: 1
            //             }
            //         }
            //     ]
            // });

        },
        //비 제품 페이지 URL 구조 개선
        bindEvents: function() {
            var self = this;

            // tabchange 로 대체 변경 // BTOCSITE-60076 [선감지][모니터링 G] 스토리 > 라이프 스타일 각 탭 키보드 방향키로 이동시 하위 내용 변경되지 않는 현상
            self.$mainTab.on('click','li a',function(e){
                e.preventDefault();
                var category1 = $(this).attr('href').replace("#","");
                var category1 = $(this).data('category');
                self.requestData({"superCategoryId":category1,"categoryId":""/*,"sort":self.$selectOrder.vcSelectbox('value')*/,"page": 1}, true, false);
                setTimeout(function() {
                    self.$list.find('li:first-child a').focus();
                }, 300)
            })

            /*self.$subTab.on('click','li a',function(e){
                e.preventDefault();
                var category1 = self.selectedTabHref(self.$mainTab);
                // var category2 = $(this).attr('href').replace("#","");
                var category2 =  $(this).data('category');
                self.requestData({"superCategoryId":category1,"categoryId":category2*//*,"sort":self.$selectOrder.vcSelectbox('value')*//*,"page": 1}, false);
            });*/

            /*
            self.$selectOrder.on('change', function(e){
                var category1 = self.selectedTabHref(self.$mainTab);
                var category2 = self.selectedTabHref(self.$subTab);
                self.requestData({"superCategoryId":category1,"categoryId":category2,"sort":self.$selectOrder.vcSelectbox('value')}, false);
            });
            */

            self.$pagination.on('page_click', function(e, data) {
                data = data !== undefined ? data : 1;
                var category1 = self.selectedTabHref(self.$mainTab);
                var category2 = self.selectedTabHref(self.$subTab);
                self.requestData({"superCategoryId":category1,"categoryId":category2/*,"sort":self.$selectOrder.vcSelectbox('value')*/,"page": data}, false);

                var currentUrl = $(location).attr('href');
                var hashArr = currentUrl.split('?')[0];
                var urlSet;
                if(category1 != null){
                    urlSet = hashArr + '?superCateId=' + category1 + '&page=' + data;
                } else{
                    urlSet = hashArr + '?page=' + data;
                }
                history.pushState(null,null,urlSet);
                setTimeout(function() { // BTOCSITE-77415 웹접근성
                    self.$list.find('li:first-child a').focus();
                }, 300)
            });

            var currentUrl = $(location).attr('href').indexOf('?') > 0 ? $(location).attr('href').split('?')[0] : $(location).attr('href');
            var urlParams = new URLSearchParams(window.location.search);
            var pageNum = urlParams.get('page');

            $('.tabs-wrap-new .tabs li').find('a[href]').each(function(i, value) { // BTOCSITE-77415 웹접근성
                if($(this).data('category') != null && $(this).data('category') != undefined){
                    $(this).prop('href', currentUrl + '?superCateId=' + $(this).data('category') + '&page=' + pageNum);
                } else{
                    $(this).prop('href', currentUrl + '&page=' + pageNum);
                    $(this).attr('id', 'mainTabs');
                    $(this).data('retrieve-url', currentUrl);
                }
            });

            var urlSet = null;
            var superCateId;
            var storyTab;

            superCateId = $(location).attr('href').indexOf('superCateId=') > 0 ? $(location).attr('href').split('superCateId=')[1] : null;

            superCateId = superCateId != null ? superCateId.split('&page=')[0] : superCateId;

            if(superCateId != null && superCateId !== undefined){
                $('.tabs-wrap-new .tabs li').find('a[href]').each(function(i, value) { // BTOCSITE-77415 웹접근성
                    if ($(this).data('category') == superCateId) {
                        storyTab = $(this);
                    }
                });
                self.requestData({"superCategoryId":superCateId,"categoryId":"","page": pageNum}, true, false);
            } else {
                $('.tabs-wrap-new .tabs li').find('a[href]').each(function(i, value) { // BTOCSITE-77415 웹접근성
                    if($(this).data('retrieve-url') == currentUrl){
                        storyTab = $(this);
                    }
                });
                urlSet = currentUrl + '?page=' + pageNum;
                //history.pushState(null,null,urlSet);
            }
            self.$mainTab.vcTab('select', storyTab.parents('li').index());

            // BTOCSITE-60076 [선감지][모니터링 G] 스토리 > 라이프 스타일 각 탭 키보드 방향키로 이동시 하위 내용 변경되지 않는 현상
            /*self.$mainTab.off('tabchange').on('tabchange', function (e, data) {
                var category1 = $(data.button).data('category');
                self.requestData({"superCategoryId":category1,"categoryId":""*//*,"sort":self.$selectOrder.vcSelectbox('value')*//*,"page": 1}, true, false);
            });*/
        },
        //비 제품 페이지 URL 구조 개선

        //비 제품 페이지 URL 구조 개선
        selectedTabHref: function($tabs) {
            if($tabs.length > 0) {
                var index = $tabs.vcTab('getSelectIdx');
                var selectTab;
                selectTab = $tabs.find('li:eq('+index+') a');
                if(selectTab.length > 0) {
                    selectTab = selectTab.data('category');
                    return selectTab;
                }
            }
            return "";
        },
        //비 제품 페이지 URL 구조 개선
        requestData: function(param, isMainTabClick, isHistoryBack) {
            var self        = this;
            var ajaxUrl     = self.$section.data('listUrl');
            var storyType   = self.$section.data('storyType');
            var tagId       = self.$section.data('tagId');

            if(storyType) {
                param.storyType = storyType;
            }

            if(tagId) {
                param.tagId = tagId;
            }

            if (ajaxUrl.indexOf("mkt") > -1) {  // 경로에 mkt 존재시 mkt api, 아니면 display api
                lgkorUI.requestAjaxDataPost(ajaxUrl, param, function(result){
                    var tempData = result.data;
                    var data = (tempData && tempData instanceof Array && tempData.length > 0) ? tempData[0] : {};
                    ajaxCallAfterProcess(self, data, param, isMainTabClick, isHistoryBack);
                });
            } else {
                lgkorUI.requestKongAjax("displaysvc", ajaxUrl, {
                    method: "POST",
                    data: param,
                    success: function(data, textStatus, jqXHR) {
                        var apiData = data.data;
                        ajaxCallAfterProcess(self, apiData, param, isMainTabClick, isHistoryBack);
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        console.log(jqXHR, textStatus, errorThrown);
                    }
                }, true, true);
            }
        },
    };
    //뒤로가기 이벤트 발생 시 하단 페이지 변경 및 ajax 재호출
    window.onpopstate = function(event) {
        var self = this;
        self.$section = $('.KRP0026');
        self.$pagination = self.$section.find('.pagination').vcPagination();
        var $pageHeader = self.$section.find('div.page-header');
        var $tabs = $pageHeader.find('div.ui_tab');
        self.$mainTab = $tabs.eq(0);

        var str;
        var urlSet;
        var storyTab;
        var superCateId = $(location).attr('href').indexOf('superCateId=') > 0 ? $(location).attr('href').split('superCateId=')[1] : null;
        superCateId = superCateId != null ? superCateId.split('&page=')[0] : superCateId;
        //var pageNum = $(location).attr('href').indexOf('page=') > 0 ? $(location).attr('href').split('page=')[1] : 1;
        if($(location).attr('href').indexOf('page=') > 0){
            var urlParams = new URLSearchParams(window.location.search);
            var pageNum = urlParams.get('page');
            KRP0026.requestData({"superCategoryId":superCateId,"categoryId":"","page": pageNum}, true, true);
        }else{
            KRP0026.requestData({"superCategoryId":superCateId,"categoryId":""}, true, true);
        }
        var targetUrl;
        targetUrl = $('#mainTabs').data('retrieve-url');
        str = superCateId != null && superCateId !== undefined ? targetUrl + '?superCateId=' + superCateId : targetUrl;
        urlSet = superCateId != null && superCateId !== undefined ? str  : targetUrl 

        self.$pagination.vcPagination('setPageInfo',pageNum);

        if(superCateId != null && superCateId !== undefined){
            $('.tabs-wrap-new .tabs li').find('a[href]').each(function(i, value) { // BTOCSITE-77415 웹접근성
                if ($(this).data('category') == superCateId) {
                    storyTab = $(this);
                }
            });
        } else {
            $('.tabs-wrap-new .tabs li').find('a[href]').each(function(i, value) { // BTOCSITE-77415 웹접근성
                if($(this).data('retrieve-url') == targetUrl){
                    storyTab = $(this);
                }
            });
        }
        self.$mainTab.vcTab('select', storyTab.parents('li').index());
    }

    function funcReady() {
        $('.KRP0026').buildCommonUI();
        KRP0026.init();
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRP0026', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP0026')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP0026')) return false;
        funcReady();
    });

    function ajaxCallAfterProcess(self, data, param, isMainTabClick, isHistoryBack) {

        var str = null;
        var urlSet = null;
        var storyTab = null;

        self.$pagination.vcPagination('setPageInfo',data.pagination);
        self.$totalCounter.text('총 '+ vcui.number.addComma(data.storyListTotalCount) +'개');

        if(isMainTabClick) {
            var arr = (data.superCategoryList && data.superCategoryList instanceof Array) ? data.superCategoryList : [];
            var $ul = self.$subTab.find('ul');
            $ul.empty();
            $ul.removeAttr("style");
            if(arr.length > 0) {
                //전체를 넣어준다
                arr.unshift({
                    "categoryName":"전체",
                    "categoryId":""
                })
            }
            arr.forEach(function(item, index) {
                $ul.append(vcui.template(subTabItemTemplate, item));
            });
            if(arr.length > 0) {
                self.$subTab.find()
                self.$subTab.vcTab('update');
                self.$subTab.vcTab('select',0);
                self.$subTab.parents('.tabs-bg').show();
            } else {
                self.$subTab.parents('.tabs-bg').hide();
            }
            //비 제품 페이지 URL 구조 개선
            var targetUrl;
            targetUrl = $('#mainTabs').data('retrieve-url');
            var superCategoryId = param.superCategoryId;
            str = superCategoryId != null && superCategoryId !== undefined ? targetUrl + '?superCateId=' + superCategoryId : targetUrl;
            urlSet = superCategoryId != null && superCategoryId !== undefined ? str + '&page=' + param.page : targetUrl + '?page=' + param.page;
            console.log(isHistoryBack);
            if(!isHistoryBack){
                history.pushState(null,null,urlSet);
                console.log('history pushState'+urlSet);
            }
        }
        //비 제품 페이지 URL 구조 개선
        var arr = data.storyList instanceof Array ? data.storyList : [];
        self.$list.empty();
        arr.forEach(function(item, index) {
            item.storyDesc = vcui.string.replaceAll(item.storyDesc, '\n', '<br>');
            self.$list.append(vcui.template(storyListItemTemplate, item));
        });
    }

})();